import { render, staticRenderFns } from "./RewardAccountsTableComponent.vue?vue&type=template&id=703f6a76&scoped=true&"
import script from "./RewardAccountsTableComponent.vue?vue&type=script&lang=js&"
export * from "./RewardAccountsTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./RewardAccountsTableComponent.vue?vue&type=style&index=0&id=703f6a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f6a76",
  null
  
)

export default component.exports